const grid = {
  formulaBar: "Formula bar",
  bold: "Bold",
  italic: "Italic",
  cellColor: "Cell Color",
  textColor: "Text Color",
  addColumn: "Add Column",
  removeColumn: "Remove Column",
  addRow: "Add Row",
  removeRow: "Remove Row",
  freezeColumn: "Freeze Column",
  undo: "Undo",
  redo: "Redo",
  exportCSV: "Export CSV",
  addSheet: "Add Sheet",
  deleteSheet: "Delete Sheet",
  duplicateSheet: "Duplicate Sheet",
} as const;
export default grid;
